import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { Chip, Typography } from '@malash-office/ui-components';

/**
 * The empty state: what to ask, split by whether it reads or changes something.
 *
 * The two tabs are not decoration — they mark the line the confirmation gate runs along. Anything
 * under "פעולות" will come back as a card to approve, and separating them here sets that
 * expectation before the first message rather than after it.
 *
 * Suggestions stay deliberately generic across modules. A role without the matching permission
 * will get a plain "you cannot do that" answer, which is honest and cheap; tailoring the list per
 * role would mean shipping a second copy of the permission model to the client.
 */

const INFO_SUGGESTIONS = [
  'כמה הזמנות פתוחות יש כרגע?',
  'אילו מוצרים מתחת לנקודת ההזמנה?',
  'מה מצב הגבייה החודש?',
  'הראה לי את חריגות המלאי',
  'אילו מבצעים פעילים עכשיו?',
  'מי עדכן את המוצר הזה לאחרונה?'
];

const ACTION_SUGGESTIONS = [
  'צור מוצר חדש בקטלוג',
  'עדכן מחיר לוריאנט',
  'הוסף לקוח חדש',
  'העבר מלאי בין מחסנים',
  'שנה סטטוס להזמנה'
];

const TABS = [
  { label: 'מידע', suggestions: INFO_SUGGESTIONS },
  { label: 'פעולות', suggestions: ACTION_SUGGESTIONS }
];

interface ChatSuggestionsProps {
  onSelect: (text: string) => void;
}

export const ChatSuggestions = ({ onSelect }: ChatSuggestionsProps) => {
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 3, px: 2 }}>
      <Typography variant="body" color="text.secondary">
        אפשר לשאול אותי על הנתונים במערכת ולבקש פעולות. כל פעולה שמשנה נתונים תוצג לאישורך לפני
        שתתבצע, והכול מוגבל להרשאות שלך. למשל:
      </Typography>

      <Tabs value={tab} onChange={(_, value) => setTab(value)} variant="fullWidth" sx={{ alignSelf: 'stretch' }}>
        {TABS.map(({ label }) => (
          <Tab key={label} label={label} sx={{ fontSize: 13 }} />
        ))}
      </Tabs>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 1 }}>
        {TABS[tab].suggestions.map(suggestion => (
          <Chip
            key={suggestion}
            label={suggestion}
            variant="primary"
            chipStyle="outlined"
            size="small"
            onClick={() => onSelect(suggestion)}
          />
        ))}
      </Box>
    </Box>
  );
};

export default ChatSuggestions;
